import { Box, Grid } from "@mui/material";
import React, { useState, useCallback, useEffect } from 'react';
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useDispatch, useSelector } from "react-redux";
import { validateModalPopManufecturing } from '../../../../utils/formik/validationSchema'
import {selectCurrentCycle, selectV2VCycle } from "../../../slices/common";
import {terminateCycle, poolCycleSubmit} from "../../../slices/manufacturer"
import {addTerminate, addPool} from '../../../../utils/formik/initialValues'
import { selectDropDownDataMaster, fetchManufecturingButtonDropDown } from "../../../slices/customMaster"


const TemplateForm = ({ slug, onUpdate={}, subject_id='', cycleList=[],handleCloseModal={} }) => {
    const dispatch = useDispatch()
      const [initialValue, setInitialValue] = useState(null);
      const [selectList, setSelectList] = useState([])
      const currentCycle = useSelector(selectCurrentCycle)
      const V2VCycle = useSelector(selectV2VCycle);
      const dropDownDataMaster = useSelector(selectDropDownDataMaster(slug))
      
      
    // Handle complete manufacturing
      const handleModelSubmit = useCallback(async(values) => {
        try {
          if(slug){
          const payload = {
             reason_id: values?.reason_id == 'other' ? '': values?.reason_id,
               ...values?.reason ? { "reason": values?.reason}:{},
               ...values?.remarks ? { "remarks": values?.remarks}:{},
              feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
              product_manufacturing_stage_id: currentCycle?.product_manufacturing_id,   
              patient_id: subject_id,        
              qr_code_generated_id: currentCycle?.qr_code_generation_id,      
             type:slug
            };
    
          const res = await dispatch(
            terminateCycle({data:payload})
          ).unwrap();
          if (res?.status == 200) {
            // Hide manufacturing actions after completion
            if(onUpdate)
              onUpdate()
              handleCloseModal()
          }
        }
        } catch (err) {
          console.error("Error completing manufacturing:", err);
        }
       }, [slug]);
    
     const handlePoolSubmit = useCallback(async(values) => {
        try {
         const currentSelected = V2VCycle?.find((it) => it?.cycle == values?.reason_id)
          const payload = {
              cycle_id: currentSelected?.product_manufacturing_id ? currentSelected?.product_manufacturing_id: null,
              cycle_feasibility_assessment_id: currentSelected?.feasibility_assessments_id,
              feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
              product_manufacturing_stage_id: currentCycle?.product_manufacturing_id,    
              patient_id: subject_id,        
              qr_code_generated_id: currentCycle?.qr_code_generation_id,     
            };
    
          const res = await dispatch(
            poolCycleSubmit({data:payload})
          ).unwrap();
          if (res?.status == 200) {
            // Hide manufacturing actions after completion
            if(onUpdate)
              onUpdate()
              handleCloseModal()
          }
        } catch (err) {
          console.error("Error completing manufacturing:", err);
        }
       }, [slug]);

    
    const formik = useFormik({
        initialValues:initialValue,
       validationSchema:validateModalPopManufecturing(slug),
        onSubmit: slug =='pool-cycles' ? handlePoolSubmit : handleModelSubmit,
        enableReinitialize: true
    })

   const formOptions = [
  {
    type: "select",
    name: "reason_id",
    label: slug === "pool-cycles" ? "Select Cycle for Pooling" : "Reason",
    placeholder: slug === "pool-cycles" ? "Select Cycle" : "Select Reason",
    options: selectList,
    required: true,
    ...(slug === "pool-cycles"
      ? {
          extraNote: `The selected ${
            formik.values?.reason_id
              ? formik.values?.reason_id
              : 'cycles'
          } will be merged to form a new cycle. Also ${
            formik.values?.reason_id
              ? `${formik.values?.reason_id} and ${currentCycle?.cycle}`
              : 'their'
          } respective status will be changed to “In-Active”`,
        }
      : {}),
  },

  // Show "Add Reason" input only if reason text should appear
  ...(formik.values?.reason_id === "other"
    ? [
        {
          type: "text",
          name: "reason",
          label: "Add Reason",
          placeholder: "Add Reason",
          required: true,
        },
      ]
    : []),

  // Show remarks only if NOT pool-cycles
  ...(slug !== "pool-cycles"
    ? [
        {
          type: "textarea",
          name: "remarks",
          label: "Description",
          placeholder: "Enter Description",
          required: false,
        },
      ]
    : []),
];

   const fetchDropDownData = useCallback(async() => {
        await dispatch(fetchManufecturingButtonDropDown(slug))
    },[slug])

  useEffect(() => {
     fetchDropDownData()
    setInitialValue(slug === 'pool-cycles' ? addPool : addTerminate)
  }, [slug]);

   
  useEffect(()=>{
  let finalDropdownData = dropDownDataMaster;
  if (slug === 'pool-cycles') {
    finalDropdownData = cycleList
  }
  if (Array.isArray(dropDownDataMaster) && dropDownDataMaster.length > 0 && slug !== 'pool-cycles') {
        finalDropdownData = [
    ...(dropDownDataMaster?.map((it) => ({
        value: it?.id,
        label: it?.name,
    })) || []),
    { value: "other", label: "Other" },
    ];
  }
 setSelectList(finalDropdownData)
},[dropDownDataMaster])


    return (
        <Box className={'w-full'}>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => (
                        <Grid key={key} item xs={12}>
                            <FormikControl formik={formik} {...props} />
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={2} className="mt-3">
                    <Grid item xs={12}>
                        <LoadingButton  fullWidth type="submit" variant="contained">{"Submit"}</LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}

export default TemplateForm;